import { useSuspenseQuery } from '@tanstack/react-query';
import { getPsychiatryNoteBySessionId } from '@uplift/api';
import { BaseSuspenseQueryOpts } from '../baseTypes';


export const useSessionPsychiatryNoteQuery = (sessionId: string, opts?: BaseSuspenseQueryOpts) => {
  return useSuspenseQuery({
    queryKey: [ 'session', sessionId, 'psychiatryNote' ],
    queryFn: async () => {
      if (!sessionId) return null;
      const response = await getPsychiatryNoteBySessionId(sessionId);

      return response.data;
    },
    ...opts
  });
};
